// Template279: Pekín - Dónde dormir (DormirPekin.jsx)
// Cabecera, intro, lista zonas (nombre, desc).

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template279 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const logoImage = getCanvasImageUrl("logo");
	const zonas = Array.isArray(page?.data?.zonas) ? page.data.zonas : [];
	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 66,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: 2.5,
					flex: 1,
					overflow: "auto",
				}}
			>
				{intro && (
					<Box component="p" sx={{ ...estiloP, marginBottom: 1.75 }}>
						{intro}
					</Box>
				)}

				<Box data-block-id="text-2" sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
					{zonas.map((z, idx) => (
						<Box
							key={z.nombre}
							data-block-id={`text-${idx + 3}`}
							sx={{
								backgroundColor: "#fff",
								borderRadius: "12px",
								padding: "12px 14px",
								border: "2px solid #e8e8e8",
							}}
						>
							<Box
								sx={{
									fontWeight: 700,
									fontSize: 13,
									color: actualHeaderColor,
									marginBottom: 0.75,
								}}
							>
								{z.nombre}
							</Box>
							{z.desc && (
								<Box
									component="p"
									sx={{ ...estiloP, fontSize: 13, margin: 0, lineHeight: 1.5 }}
								>
									{z.desc}
								</Box>
							)}
						</Box>
					))}
				</Box>
			</Box>
		</Box>
	);
};

Template279.thumbnail = "/images/template-1.png";
export default Template279;
